import { render } from "./myNoble.vue?vue&type=template&id=048fffee&scoped=true"
import script from "./myNoble.vue?vue&type=script&lang=js"
export * from "./myNoble.vue?vue&type=script&lang=js"

import "./myNoble.vue?vue&type=style&index=0&id=048fffee&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-048fffee"]])

export default __exports__